























import Vue from 'vue'

import P5BoxBlock from './P5BoxBlock.vue'
import P5ConeBlock from './P5ConeBlock.vue'
import P5CylinderBlock from './P5CylinderBlock.vue'
import P5DodecahedronBlock from './P5DodecahedronBlock.vue'
import P5EllipsoidBlock from './P5EllipsoidBlock.vue'
import P5IcosahedronBlock from './P5IcosahedronBlock.vue'
import P5OctahedronBlock from './P5OctahedronBlock.vue'
import P5PlaneBlock from './P5PlaneBlock.vue'
import P5TetrahedronBlock from './P5TetrahedronBlock.vue'
import P5TorusBlock from './P5TorusBlock.vue'

import vueSlider from './VueSliderComponent.vue'

import dictionary from '../assets/dictionary.json'
import { common } from '../assets/blockCommons'

export default Vue.extend({
  name: 'P5Block',
  components: {
    P5BoxBlock,
    P5ConeBlock,
    P5CylinderBlock,
    P5DodecahedronBlock,
    P5EllipsoidBlock,
    P5IcosahedronBlock,
    P5OctahedronBlock,
    P5PlaneBlock,
    P5TorusBlock,
    P5TetrahedronBlock,
    vueSlider
  },
  props: common.props,
  data () {
    return {
      blockSelection: '',
      options: {
        width: "90%",
        value: "",
        tooltip: "always",
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        data: [
          "",
          "Box",
          "Cone",
          "Cylinder",
          "Dodecahedron",
          "Ellipsoid",
          "Plane",
          "Icosahedron",
          "Torus",
          "Octahedron",
          "Tetrahedron"
        ],
        piecewiseStyle: {
          "backgroundColor": "#ccc",
          "visibility": "visible",
          "width": "12px",
          "height": "12px"
        },
        piecewiseActiveStyle: {
          "backgroundColor": "#ccc"
        },
        labelActiveStyle: {
          "color": "#333"
        },
        tooltipStyle: [
          {
            "color": "#000",
            "backgroundColor": "#6abe95",
            "borderColor": "transparent"
          },
          {
            "color": "#000",
            "backgroundColor": "transparent",
            "borderColor": "transparent"
          }
        ],
        sliderStyle: [
          {
            "backgroundColor": "#ccc"
          }
        ],
        processStyle: {
          "backgroundColor": "#ccc"
        }
      }
    }
  },
  computed: {
    url(): String | undefined {
      return 'https://' + process.env.VUE_APP_URL + '/icons/'
    },
    definition(): String {
      let key = this.title.toLowerCase()
      return dictionary[key].definition
    },
    synonyms(): String {
      let key = this.title.toLowerCase()
      return dictionary[key].synonyms
    }
  }
})
